import React, { useEffect, useState, forwardRef, useRef } from 'react'
import axios from '../axios';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Delete from '@mui/icons-material/Delete';
import Info from '@mui/icons-material/Info';
import { Checkbox, Chip, FormControl, FormHelperText, IconButton, Input, InputLabel, InputAdornment } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import { MenuItem } from '@mui/material';
import { useStateValue } from '../StateProvider';
import { actionTypes } from '../reducer';
// import { red } from '@mui/material/colors';
import { statesArr } from "../helpers/constantVariables";
import { useInput, NumberFormatCustom, TextMaskCustom, TextMaskCustomSSN, TextMaskCustomDate, TextMaskCustomPhone, TextMaskCustomTaxID, TextMaskCustomZipCode, TextMaskCustom0to99, TextMaskCustomPercent, TextMaskCustomMCDOT, TextMaskCustomYear, TextMaskCustomDateNoMax } from "../hooks/inputHook";
import StepButtons from '../components/StepButtons';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import { RedeemRounded, Remove, Visibility, VisibilityOff } from '@mui/icons-material';
import Tab from '@mui/material/Tab';
import { DatePicker } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import moment from 'moment';
import { fieldValidationDriversLicense, fieldValidationLegalAge, fieldValidationOwnerMCDOTOptional, fieldValidationAmount, fieldValidationTaxID, fieldValidationWebsite, fieldValidation, fieldValidationPhone, fieldValidationEmail, fieldValidationSSN, fieldValidationLicenseNum, fieldValidationZipCode, fieldValidation0to99, fieldValidationFloat, fieldValidationMCDOT, fieldValidationDate } from "../validators/fieldValidation"
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Grid container item
      textAlign="left"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Grid xs={6} columnSpacing={{ xs: 2, sm: 3, md: 4 }} paddingLeft={0} paddingRight={4} container item style={{ borderRadius: '10px', boxShadow: '0px 0px 3px #888888', marginTop: '20px', marginLeft: "0px", paddingBottom: "20px", paddingTop: "20px", background: 'white' }}>
          <>{children}</>
        </Grid>
      )}
    </Grid>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function BusinessInfo({ },ref) {
  const [{ applicantDetails, activeStep, progressStep, hideHauling }, dispatch] = useStateValue();

  //Business Info
  const { value: address1, setValue: setAddress1, bind: bindAddress1 } = useInput(applicantDetails?.address1);
  const { value: states, setValue: setStates, bind: bindStates } = useInput(applicantDetails?.state);
  const { value: city, setValue: setCity, bind: bindCity } = useInput(applicantDetails?.city);
  const { value: zipcode, setValue: setZipcode, bind: bindZipcode } = useInput(applicantDetails?.zipcode);
  //Trucking Info
  const { value: isTransportation, setValue: setIsTransportation, bind: bindIsTransportation, } = useInput(applicantDetails?.is_transportation);
  const { value: isFinanced, setValue: setIsFinanced, bind: bindIsFinanced, } = useInput(applicantDetails?.is_financed);
  const { value: isPurchase, setValue: setIsPurchase, bind: bindIsPurchase, } = useInput(applicantDetails?.is_purchase);
  const { value: fleetSize, setValue: setFleetSize, bind: bindFleetSize, } = useInput(applicantDetails?.fleet_size);
  const { value: withDebtors, setValue: setWithDebtors, bind: bindWithDebtors, } = useInput(applicantDetails?.with_debtors);
  //non-DB
  const { value: isMcAuthority, setValue: setIsMcAuthority, bind: bindIsMcAuthority, } = useInput(applicantDetails?.isMcAuthority);
  //const [ mcRadioValue, setMcRadioValue ] = useState('');
  //----//
  const { value: dot, setValue: setDot, bind: bindDot, } = useInput(applicantDetails?.dot || '');
  const { value: mc, setValue: setMc, bind: bindMc, } = useInput(applicantDetails?.businessinfo_mc || '');
  const { value: numOfTrucks, setValue: setNumOfTrucks, bind: bindNumOfTrucks, } = useInput(applicantDetails?.number_of_trucks);
  const { value: numOfTrailers, setValue: setNumOfTrailers, bind: bindNumOfTrailers, } = useInput(applicantDetails?.number_of_trailers);
  const { value: yearEstablished, setValue: setYearEstablished, bind: bindYearEstablished, } = useInput(applicantDetails?.year_established || '');
  const { value: businessState, setValue: setBusinessState, bind: bindBusinessState, } = useInput(applicantDetails?.business_state);
  const { value: currentlyFactoring, setValue: setCurrentlyFactoring, bind: bindCurrentlyFactoring, } = useInput(applicantDetails?.currently_factoring);
  const { value: factoringWith, setValue: setFactoringWith, bind: bindFactoringWith, } = useInput(applicantDetails?.factoring_with || '');

  //Other Important Info
  const { value: isGambling, setValue: setIsGambling, bind: bindIsGambling, } = useInput(applicantDetails?.is_gambling);
  const { value: isMoneyService, setValue: setIsMoneyService, bind: bindIsMoneyService, } = useInput(applicantDetails?.is_money_service);

  const { value: isNotUSCitizen, setValue: setIsNotUSCitizen, bind: bindIsNotUSCitizen, } = useInput(applicantDetails?.not_us_citizen_note || '');
  const { value: isPEP, setValue: setIsPEP, bind: bindIsPEP, } = useInput(applicantDetails?.politically_exposed);


  const { value: helpedBy, setValue: setHelpedBy, bind: bindHelpedBy, } = useInput(applicantDetails?.helped_by || '');
  const { value: salesPerson, setValue: setSalesPerson, bind: bindSalesPerson } = useInput(applicantDetails?.helped_by || '');
  const [salesPersons, setSalesPersons] = useState([]);
  const { value: requestedCreditLimit, setValue: setRequestedCreditLimit, bind: bindRequestedCreditLimit, } = useInput(applicantDetails?.requested_credit_limit || '0.00');

  const [showSSN, setShowSSN] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openDebtor, setOpenDebtors] = React.useState(false);
  const [addOwner, setAddOwner] = useState(0);
  const [totalOwnership, setTotalOwnership] = useState(1);
  const [ownerValidate, setOwnerValidate] = useState(false);
  const [debtorValidate, setDebtorValidate] = useState(false);
  const tabContainerRef = useRef(null); //set ref entire tab container

  //Owners
  const [owners, setOwners] = useState(applicantDetails?.owners ? applicantDetails?.owners :
    [
      {
        //loan_guarantor: false,
        beneficial_owner: false,
        control_owner: false,
        first_name: '',
        middle_name: '',
        last_name: '',
        email: '',
        home_phone: '',
        mobile_phone: '',
        date_of_birth: '',
        title: '',
        years_driving: '',
        ssn: '',
        ownership_percent: '',
        phys_address1: '',
        phys_city: '',
        phys_state: '',
        phys_zipcode: '',
        phys_country: '',
        same_address: false,
        same_address_garage: false,
        mail_address1: '',
        mail_city: '',
        mail_state: '',
        mail_zipcode: '',
        garage_address1: '',
        garage_city: '',
        garage_state: '',
        garage_zipcode: '',
        mail_country: '',
        declared_bankruptcy: '',
        defendant_legal: '',
        item_repossessed: '',
        dl_exp_date: null,
        dl_state: ''
      },
    ]);

  // DEBTORS   
  const [debtors, setDebtors] = useState(applicantDetails?.debtors ? applicantDetails?.debtors : []);
  const [showTaxId, setShowTaxId] = useState(false);
  const [value, setValue] = useState(0);
  const [valueDebtors, setValueDebtors] = useState(0);

  const handleClickShowTaxId = () => {
    setShowTaxId(!showTaxId);
  };

  const handleMouseDownTaxId = (event) => {
    event.preventDefault();
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const switchDebtorsTab = (event, newValue) => {
    setValueDebtors(newValue);
  };

  const handleMouseDownSSN = (event) => {
    event.preventDefault();
  };

  const handleClickShowSSN = () => {
    setShowSSN(!showSSN);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpenDebtors = () => {
    setOpenDebtors(true);
  };
  const handleCloseDebtors = () => {
    setOpenDebtors(false);
  };


  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('localstorage'))
    //console.log(items);
    if (items) {
      // setLegitEntity(items.legit_entity);
      // setCompanyName(items.business_name);
      // setEmail(items.email);
      // setBusinessPhone(items.phone);
      // setTaxId(items.ein);
      // setDoingBusinessAs(items.dba);
      // setMobile(items.mobile);
      // setWebsite(items.website);
    }
  }, []);


  const handleChangeOwner = (index, event) => {
    const values = [...owners];
    values[index][event.target.name] = event.target.value;
    setOwners(values);
    if (values[index]['mail_address1'] !== owners[index]['phys_address1']
      || values[index]['mail_state'] !== owners[index]['phys_state']
      || values[index]['mail_state'] !== owners[index]['phys_state']
      || values[index]['mail_city'] !== owners[index]['phys_city']
      || values[index]['mail_zipcode'] !== owners[index]['phys_zipcode']) {
      values[index]['same_address'] = false;
    } else {
      values[index]['same_address'] = true;
    }
    if (values[index]['garage_address1'] !== owners[index]['phys_address1']
      || values[index]['garage_state'] !== owners[index]['phys_state']
      || values[index]['garage_city'] !== owners[index]['phys_city']
      || values[index]['garage_zipcode'] !== owners[index]['phys_zipcode']) {
      values[index]['same_address_garage'] = false;
    } else {
      values[index]['same_address_garage'] = true;
    }
  }

  const handleChangeDebtor = (index, event) => {
    const values = [...debtors];
    values[index][event.target.name] = event.target.value;
    setDebtors(values);
  }

  const handleInvoiceAmount = (index, event) => {
    const values = [...debtors];
    const newNumber = Number(event.target.value).toFixed(2);
    values[index][event.target.name] = newNumber;
    setDebtors(values);

  }

  const handlieCreditLimit = (event) => {
    const values = event.target.value;
    const newValue = Number(values).toFixed(2);
    // console.log(newValue);
    setRequestedCreditLimit(newValue);
  }

  const handleChangeOwnerCheck = (index, event) => {
    const values = [...owners];
    values[index][event.target.name] = event.target.checked;
    if (event.target.name === 'same_address' && event.target.checked) {
      values[index]['mail_address1'] = owners[index]['phys_address1'];
      values[index]['mail_state'] = owners[index]['phys_state'];
      values[index]['mail_city'] = owners[index]['phys_city'];
      values[index]['mail_zipcode'] = owners[index]['phys_zipcode'];
    }
    if (event.target.name === 'same_address_garage' && event.target.checked) {
      values[index]['garage_address1'] = owners[index]['phys_address1'];
      values[index]['garage_state'] = owners[index]['phys_state'];
      values[index]['garage_city'] = owners[index]['phys_city'];
      values[index]['garage_zipcode'] = owners[index]['phys_zipcode'];
    }
    setOwners(values);
  }

  const handleChangeOwnerDate = (index, name, newValue) => {
    const values = [...owners];
    values[index][name] = newValue;
    setOwners(values);
  }

  const handleAddOwner = () => {
    setOwners([...owners,
    {
      //loan_guarantor: false,
      beneficial_owner: false,
      control_owner: false,
      first_name: '',
      middle_name: '',
      last_name: '',
      email: '',
      home_phone: '',
      mobile_phone: '',
      date_of_birth: '',
      title: '',
      years_driving: '',
      ssn: '',
      ownership_percent: '',
      phys_address1: '',
      phys_city: '',
      phys_state: '',
      phys_zipcode: '',
      phys_country: '',
      same_address: false,
      same_address_garage: false,
      mail_address1: '',
      mail_city: '',
      mail_state: '',
      mail_zipcode: '',
      garage_address1: '',
      garage_city: '',
      garage_state: '',
      garage_zipcode: '',
      mail_country: '',
      declared_bankruptcy: '',
      defendant_legal: '',
      item_repossessed: '',
      dl_exp_date: null,
      dl_state: '',
    },]);
    setValue(owners?.length);

    //scroll to tabpanel container
    tabContainerRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  const handleRemoveOwner = (i) => {
    let filteredOwners = owners.filter((owner, index) => index !== i)
    setOwners(filteredOwners);
    setValue(value - 1);
    handleClose();
  }

  const handleAddDebtor = () => {
    setDebtors([...debtors,
    {
      name: '',
      mc: '',
      dot: '',
      ein: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zipcode: '',
      country: '',
      phone: '',
      email: '',
      website: '',
      invoice_amount: ''
    },]);
    setValueDebtors(debtors?.length);
  }

  const handleRemoveDebtor = (i) => {
    let filteredDebtors = debtors.filter((debtor, index) => index !== i)
    setDebtors(filteredDebtors);
    setValueDebtors(valueDebtors - 1);
    handleCloseDebtors();
  }

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 280,
      fontSize: theme.typography.pxToRem(11),
      border: '1px solid #dadde9',
    },
  }));

  const updateApplicantDetails = () => {
    dispatch({
      type: actionTypes.SET_SUBMIT_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        address1: address1,
        state: states,
        city: city,
        zipcode: zipcode,
        is_transportation: isTransportation,
        is_financed: isFinanced,
        is_purchase: isPurchase,
        fleet_size: fleetSize,
        isMcAuthority: isMcAuthority,
        dot: dot,
        businessinfo_mc: mc,
        number_of_trucks: numOfTrucks,
        number_of_trailers: numOfTrailers,
        year_established: yearEstablished,
        business_state: businessState,
        currently_factoring: currentlyFactoring,
        factoring_with: factoringWith,
        is_gambling: isGambling,
        is_money_service: isMoneyService,
        politically_exposed: isPEP,
        not_us_citizen_note: isNotUSCitizen,
        helped_by: salesPerson,
        requested_credit_limit: requestedCreditLimit,
        owners,
        with_debtors: withDebtors,
        debtors,
      },
    });
  }

  const onUpdateBusinessInfo = () => {
    let validation = validate();
    let validationOwners = validateOwners();
    let validationDebtors = validateDebtors();
    // console.log(validationOwners);
    // console.log(validationDebtors);
    setOwnerValidate(validationOwners.error)
    setDebtorValidate(validationDebtors.error)
    updateApplicantDetails();

    return validation;
  }

  const validate = () => {
    let validateSuccess = { error: false, msg: "" };
    let success = {}
    success = fieldValidation(address1, "Address");
    if (success.error) return success;
    success = fieldValidation(states, "State");
    if (success.error) return success;
    success = fieldValidation(city, "City");
    if (success.error) return success;
    success = fieldValidationZipCode(zipcode, "Zip Code");
    if (success.error) return success;
    success = fieldValidation(isTransportation, "Trucking Information");
    if (success.error) return success;
    if (isTransportation === 'true') {
      success = fieldValidation(isFinanced, "Have you ever financed a truck/trailer question");
      if (success.error) return success;
      success = fieldValidation(isPurchase, "Is purchase a Replacement/Addition question");
      if (success.error) return success;
      success = fieldValidation(fleetSize, "Fleet Size question");
      if (success.error) return success;
      success = fieldValidation(numOfTrucks, "Number of Trucks question");
      if (success.error) return success;
      success = fieldValidation(numOfTrailers, "Number of Trailers question");
      if (success.error) return success;
      success = fieldValidation(isMcAuthority, "MC Authority question");
      if (success.error) return success;
      if (isMcAuthority === 'true') {
        /* success = fieldValidation(mc, "MC#");
        if (success.error) return success;
        success = fieldValidation(numOfTrucks, "Number of Trucks");
        if (success.error) return success; */
        success = fieldValidation(currentlyFactoring, "Accounts receivable question");
        if (success.error) return success;
      }
    }
    success = fieldValidation(businessState, "Business State");
    if (success.error) return success;
    //success = fieldValidation(currentlyFactoring, "Accounts receivable question");
    //if (success.error) return success;
    success = fieldValidation(isGambling, "Internet Gambling question");
    if (success.error) return success;
    success = fieldValidation(isMoneyService, "MSB question");
    if (success.error) return success;
    success = fieldValidation(isPEP, "PEP question");
    if (success.error) return success;
    // success = fieldValidation(withDebtors, "Debtors question");
    // if (success.error) return success;
    success = fieldValidation(yearEstablished, "Year Established");
    if (success.error) return success;

    //OWNERS
    // owners.map((owner, index) => {
    let ownershipTotal = 0;
    let individualWithControl = 0;
    for (var i = 0; i < owners?.length; i++) {
      ownershipTotal += Number(owners[i].ownership_percent);
      individualWithControl = (owners[i].control_owner ? 1 : 0) + individualWithControl;
      //BASIC INFO
      success = fieldValidation(owners[i].first_name, `Owner ${i + 1} First Name`);
      if (success.error) return success;
      success = fieldValidation(owners[i].last_name, `Owner ${i + 1} Last Name`);
      if (success.error) return success;
      // success = fieldValidation(owners[i].middle_name,`Owner ${i+1} Middle Name`);
      // if(success.error) return success;
      success = fieldValidationEmail(owners[i].email, `Owner ${i + 1} Email`);
      if (success.error) return success;
      // success = fieldValidationPhone(owners[i].mobile_phone, `Owner ${i + 1} Mobile`);
      // if (success.error) return success;
      //success = fieldValidationPhone(owners[i].home_phone, `Owner ${i + 1} Home Phone`);
      //if (success.error) return success;
      success = fieldValidationLegalAge(owners[i].date_of_birth, `Owner ${i + 1} Date of Birth`);
      if (success.error) return success;
      success = fieldValidationSSN(owners[i].ssn, `Owner ${i + 1} SSN`);
      if (success.error) return success;
      success = fieldValidation(owners[i].title, `Owner ${i + 1} Title`);
      if (success.error) return success;
      success = fieldValidationFloat(owners[i].ownership_percent, `Owner ${i + 1} Ownership Percent`);
      if (success.error) return success;
      success = fieldValidation0to99(owners[i].years_driving, `Owner ${i + 1} Years Driving`);
      if (success.error) return success;

      //PHYSICAL ADDRESS
      success = fieldValidation(owners[i].phys_address1, `Owner ${i + 1} Physical Address`);
      if (success.error) return success;
      success = fieldValidation(owners[i].phys_state, `Owner ${i + 1} Physical State`);
      if (success.error) return success;
      success = fieldValidation(owners[i].phys_city, `Owner ${i + 1} Physical City`);
      if (success.error) return success;
      success = fieldValidationZipCode(owners[i].phys_zipcode, `Owner ${i + 1} Physical Zip Code`);
      if (success.error) return success;

      //MAILING ADDRESS
      success = fieldValidation(owners[i].mail_address1, `Owner ${i + 1} Mail Address`);
      if (success.error) return success;
      success = fieldValidation(owners[i].mail_state, `Owner ${i + 1} Mail State`);
      if (success.error) return success;
      success = fieldValidation(owners[i].mail_city, `Owner ${i + 1} Mail City`);
      if (success.error) return success;
      success = fieldValidationZipCode(owners[i].mail_zipcode, `Owner ${i + 1} Mail Zipcode`);
      if (success.error) return success;

      success = fieldValidation(owners[i].declared_bankruptcy, `Owner ${i + 1} Declared Bankruptcy`);
      if (success.error) return success;
      success = fieldValidation(owners[i].defendant_legal, `Owner ${i + 1} Defendant in any Legal Action`);
      if (success.error) return success;
      success = fieldValidation(owners[i].item_repossessed, `Owner ${i + 1} Item repossessed`);
      if (success.error) return success;

    }

      if (ownershipTotal < 80)
        return { error: true, msg: "Total Ownership % must be greater or equal to 80%" };
      if (ownershipTotal > 100)
        return { error: true, msg: "The total percentage of business ownership exceeds 100%. Please review and correct signer ownership percentages." };
      if(individualWithControl == 0)
        return {error: true, msg: "The application must have a Individual with Control."};
      if (success.error) return success;

    for (var i = 0; i < debtors?.length; i++) {
      //BASIC INFO
      success = fieldValidation(debtors[i].name, `Debtor ${i + 1} Name`);
      if (success.error) return success;
      success = fieldValidationEmail(debtors[i].email, `Debtor ${i + 1} Email`);
      if (success.error) return success;
      success = fieldValidationPhone(debtors[i].phone, `Debtor ${i + 1} Phone`);
      if (success.error) return success;
      // success = fieldValidationWebsite(debtors[i].website, `Debtor ${i + 1} Website`);
      // if (success.error) return success;
      // success = fieldValidationMCDOT(debtors[i].mc, `Debtor ${i + 1} MC#`);
      // if (success.error) return success;
      // success = fieldValidationTaxID(debtors[i].ein, `Debtor ${i + 1} Tax ID`);
      // if (success.error) return success;
      // success = fieldValidationMCDOT(debtors[i].dot, `Debtor ${i + 1} USDOT#`);
      // if (success.error) return success;
      success = fieldValidation(debtors[i].invoice_amount, `Debtor ${i + 1} Invoice Amount`);
      if (success.error) return success;
      success = fieldValidation(debtors[i].address1, `Debtor ${i + 1} Address`);
      if (success.error) return success;
      success = fieldValidation(debtors[i].city, `Debtor ${i + 1} City`);
      if (success.error) return success;
      success = fieldValidation(debtors[i].state, `Debtor ${i + 1} State`);
      if (success.error) return success;
      success = fieldValidationZipCode(debtors[i].zipcode, `Debtor ${i + 1} Zip Code`);
      if (success.error) return success;
    }
    //total ownership Check
    // console.log("totalOwnership:", totalOwnership);
    // if (totalOwnership < 66.66) return { error: true, msg: "Total Ownership Doesn't Exceed 66.66% requirements. Please check and set guarantors ownership to > 66.66%" }

    return validateSuccess;
  }



  const validateOwners = () => {
    let validateSuccess = { error: false, msg: "" };
    let success = {}
    //OWNERS
    // owners.map((owner, index) => {
    for (var i = 0; i < owners?.length; i++) {
      //BASIC INFO
      success = fieldValidation(owners[i].first_name, `Owner ${i + 1} First Name`);
      if (success.error) return success;
      success = fieldValidation(owners[i].last_name, `Owner ${i + 1} Last Name`);
      if (success.error) return success;
      // success = fieldValidation(owners[i].middle_name,`Owner ${i+1} Middle Name`);
      // if(success.error) return success;
      success = fieldValidationEmail(owners[i].email, `Owner ${i + 1} Email`);
      if (success.error) return success;
      // success = fieldValidationPhone(owners[i].mobile_phone, `Owner ${i + 1} Mobile`);
      // if (success.error) return success;
      //success = fieldValidationPhone(owners[i].home_phone, `Owner ${i + 1} Home Phone`);
      //if (success.error) return success;
      success = fieldValidationLegalAge(owners[i].date_of_birth, `Owner ${i + 1} Date of Birth`);
      if (success.error) return success;
      success = fieldValidationSSN(owners[i].ssn, `Owner ${i + 1} SSN`);
      if (success.error) return success;
      success = fieldValidation(owners[i].title, `Owner ${i + 1} Title`);
      if (success.error) return success;
      success = fieldValidationFloat(owners[i].ownership_percent, `Owner ${i + 1} Ownership Percent`);
      if (success.error) return success;
      success = fieldValidation0to99(owners[i].years_driving, `Owner ${i + 1} Years Driving`);
      if (success.error) return success;

      //PHYSICAL ADDRESS
      success = fieldValidation(owners[i].phys_address1, `Owner ${i + 1} Physical Address`);
      if (success.error) return success;
      success = fieldValidation(owners[i].phys_state, `Owner ${i + 1} Physical State`);
      if (success.error) return success;
      success = fieldValidation(owners[i].phys_city, `Owner ${i + 1} Physical City`);
      if (success.error) return success;
      success = fieldValidationZipCode(owners[i].phys_zipcode, `Owner ${i + 1} Physical Zip Code`);
      if (success.error) return success;

      //MAILING ADDRESS
      success = fieldValidation(owners[i].mail_address1, `Owner ${i + 1} Mail Address`);
      if (success.error) return success;
      success = fieldValidation(owners[i].mail_state, `Owner ${i + 1} Mail State`);
      if (success.error) return success;
      success = fieldValidation(owners[i].mail_city, `Owner ${i + 1} Mail City`);
      if (success.error) return success;
      success = fieldValidationZipCode(owners[i].mail_zipcode, `Owner ${i + 1} Mail Zipcode`);
      if (success.error) return success;
      success = fieldValidation(owners[i].declared_bankruptcy, `Owner ${i + 1} Declared Bankruptcy Question`);
      if (success.error) return success;
      success = fieldValidation(owners[i].defendant_legal, `Owner ${i + 1} Defendant in any Legal Action Question`);
      if (success.error) return success;
      success = fieldValidation(owners[i].item_repossessed, `Owner ${i + 1} Item repossessed Question`);
      if (success.error) return success;
    }
    return validateSuccess
  }

  const validateDebtors = () => {
    let validateSuccess = { error: false, msg: "" };
    let success = {}
    //DEBTORS
    // debtors.map((debtor, index) => {
    for (var i = 0; i < debtors?.length; i++) {
      //BASIC INFO
      success = fieldValidation(debtors[i].name, `Debtor ${i + 1} Name`);
      if (success.error) return success;
      success = fieldValidationEmail(debtors[i].email, `Debtor ${i + 1} Email`);
      if (success.error) return success;
      success = fieldValidationPhone(debtors[i].phone, `Debtor ${i + 1} Phone`);
      if (success.error) return success;
      // success = fieldValidationWebsite(debtors[i].website, `Debtor ${i + 1} Website`);
      // if (success.error) return success;
      // success = fieldValidationMCDOT(debtors[i].mc, `Debtor ${i + 1} MC#`);
      // if (success.error) return success;
      // success = fieldValidationTaxID(debtors[i].ein, `Debtor ${i + 1} Tax ID`);
      // if (success.error) return success;
      // success = fieldValidationMCDOT(debtors[i].dot, `Debtor ${i + 1} USDOT#`);
      // if (success.error) return success;
      success = fieldValidationAmount(debtors[i].invoice_amount, `Debtor ${i + 1} Invoice Amount`);
      if (success.error) return success;
      success = fieldValidation(debtors[i].address1, `Debtor ${i + 1} Address`);
      if (success.error) return success;
      success = fieldValidation(debtors[i].city, `Debtor ${i + 1} City`);
      if (success.error) return success;
      success = fieldValidation(debtors[i].state, `Debtor ${i + 1} State`);
      if (success.error) return success;
      success = fieldValidationZipCode(debtors[i].zipcode, `Debtor ${i + 1} Zip Code`);
      if (success.error) return success;
    }
    return validateSuccess
  }

  useEffect(() => {
    // axios
    //   .get("/api/get_salespersons")
    //   .then((response) => {
    //     // console.log(response);
    //     setSalesPersons(response.data);
    //   });

    if (owners.length > 0) {
      let filteredOwners = owners.filter((owner) => owner.loan_guarantor != 0)
      // console.log("guarantors percentage:", filteredOwners);
      let totalOwnershipVal = filteredOwners?.map(datum => parseFloat(datum.ownership_percent)).reduce((a, b) => a + b, 0);
      setTotalOwnership(totalOwnershipVal);
    }
    let validation = validateOwners();
    setOwnerValidate(validation.error);
  }, [owners]);

  useEffect(() => {
    //console.log("isMcAuthority",isMcAuthority);
    //localStorage.removeItem('useOwnMcAuthority');
    const storedValue = localStorage.getItem('useOwnMcAuthority');
    if (storedValue) {
      setIsMcAuthority(storedValue);
      //setMcRadioValue(storedValue);
    }
  }, [isMcAuthority])
  

  const handleUseMcAuthority = (e) => {
    const value = e.target.value;
    setIsMcAuthority(value);
    //setMcRadioValue(value);
    localStorage.setItem('useOwnMcAuthority', value);
    updateApplicantDetails();
    dispatch({
      type: actionTypes.SET_HIDE_HAULING,
      hideHauling: value === "true" ? 1 : 0
    });
    //console.log("hideHauling",value);
    if(progressStep == 6 && value === "true"){
        dispatch({
            type: actionTypes.SET_PROGRESS_STEP,
            progressStep: progressStep - 1
        });
    }
    if(progressStep == 5 && value === "false"){
        dispatch({
            type: actionTypes.SET_PROGRESS_STEP,
            progressStep: progressStep + 1
        });
    }
  }

  return (
    <>
      <Grid item container textAlign="left" columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
        <Grid textAlign="left" item xs={12}>
          <Typography color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
            Business Information
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <TextField
            placeholder="Physical Address"
            label="Physical Address"
            name="address1"
            autoComplete='off'
            {...bindAddress1}
            required={true}
            error={fieldValidation(address1, "Physical Address").error}
            helperText={fieldValidation(address1, "Physical Address").msg}
            margin="normal"
            fullWidth
            variant="standard"
          />
          <TextField
            id="state"
            placeholder="State"
            label="State"
            margin="normal"
            fullWidth
            variant="standard"
            select
            required={true}
            error={fieldValidation(states, "State").error}
            helperText={fieldValidation(states, "State").msg}
            name="states"{...bindStates}
          >
            {(statesArr || []).map((states) => (
              <MenuItem key={states.code} value={states.code}>
                {states.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <TextField
            placeholder="City"
            label="City"
            name="city"
            autoComplete='off'
            {...bindCity}
            required={true}
            error={fieldValidation(city, "City").error}
            helperText={fieldValidation(city, "City").msg}
            margin="normal"
            fullWidth
            variant="standard"
          />
          <FormControl required={true} error={fieldValidationZipCode(zipcode, "Zip Code").error} variant="standard" margin="normal"
            fullWidth>
            <InputLabel htmlFor="formatted-text-mask-input">Zip Code</InputLabel>
            <Input
              {...bindZipcode}
              name="zipcode"
              id="zipcode"
              autoComplete='off'
              inputComponent={TextMaskCustomZipCode}
            />
            <FormHelperText>{fieldValidationZipCode(zipcode, "Zip Code").msg}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid textAlign="left" item xs={12} marginTop={6}>
          <Typography color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
            Trucking Information
          </Typography>
        </Grid>
        <Grid container item columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <Typography marginTop={2} color={isTransportation ? "#616365" : "#c02424"} variant="subtitle1" component="div">
              This Business is involved in the transportation/trucking industry.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <RadioGroup
              row
              aria-labelledby="demo-form-control-label-placement"
              name="position"
              required={true}
              sx={"margin-top:10px"}
              error={isTransportation ? false : true}
              {...bindIsTransportation}
            >
              <FormControlLabel required={true} value="true" control={<Radio />} label="Yes" />
              <FormControlLabel required={true} value="false" control={<Radio />} label="No" />
            </RadioGroup>
          </Grid>
          {isTransportation == "true" &&
            <>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <Typography marginTop={2} color={isFinanced ? "#616365" : "#c02424"} variant="subtitle1" component="div">
                  Have you ever financed a truck/trailer?
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-form-control-label-placement"
                  name="is_financed"
                  required={true}
                  sx={"margin-top:10px"}
                  error={isFinanced ? false : true}
                  {...bindIsFinanced}
                >
                  <FormControlLabel required={true} value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel required={true} value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <Typography marginTop={2} color={isPurchase ? "#616365" : "#c02424"} variant="subtitle1" component="div">
                  Is this purchase a
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-form-control-label-placement"
                  name="is_purchased"
                  required={true}
                  sx={"margin-top:10px"}
                  error={isPurchase ? false : true}
                  {...bindIsPurchase}
                >
                  <FormControlLabel required={true} value="replacement" control={<Radio />} label="Replacement" />
                  <FormControlLabel required={true} value="addition" control={<Radio />} label="Addition" />
                </RadioGroup>
              </Grid>
              <Grid item xs={12} md={4} lg={4} xl={4}>
                <TextField
                  placeholder="Fleet Size"
                  label="Fleet Size"
                  name="fleet_size"
                  autoComplete='off'
                  {...bindFleetSize}
                  required={true}
                  error={fieldValidation(fleetSize, "Fleet Size").error}
                  helperText={fieldValidation(fleetSize, "Fleet Size").msg}
                  margin="normal"
                  fullWidth
                  variant="standard"
                  type='number'
                  inputProps={{min:0}}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4} xl={4}>
                <TextField
                  placeholder="Number of Trucks"
                  label="Number of Trucks"
                  name="number_of_trucks"
                  autoComplete='off'
                  {...bindNumOfTrucks}
                  required={true}
                  error={fieldValidation(numOfTrucks, "Number of Trucks").error}
                  helperText={fieldValidation(numOfTrucks, "Number of Trucks").msg}
                  margin="normal"
                  fullWidth
                  variant="standard"
                  type='number'
                  inputProps={{min:0}}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4} xl={4}>
                <TextField
                  placeholder="Number of Trailers"
                  label="Number of Trailers"
                  name="number_of_trailers"
                  autoComplete='off'
                  {...bindNumOfTrailers}
                  required={true}
                  error={fieldValidation(numOfTrailers, "Number of Trailers").error}
                  helperText={fieldValidation(numOfTrailers, "Number of Trailers").msg}
                  margin="normal"
                  fullWidth
                  variant="standard"
                  type='number'
                  inputProps={{min:0}}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <Typography marginTop={2} color={isMcAuthority ? "#616365" : "#c02424"}
                  variant="subtitle1" component="div">
                  Do you run under your own Motor Carrier (MC) Authority?
                {/* {isMcAuthority == "true" && <><br /><Typography variant='body2' color='secondary'>Hauling reference will be skipped.</Typography></> } */}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <RadioGroup
                  row
                  aria-labelledby="demo-form-control-label-placement"
                  name="isMcAuthority"
                  {...bindIsMcAuthority}
                  required={true}
                  sx={"margin-top:10px"}
                  onChange={handleUseMcAuthority}
                  value={localStorage.getItem('useOwnMcAuthority')}
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </Grid>
            {isMcAuthority == "true" &&
              <>
                <Grid item xs={12} md={6} lg={6} xl={6}>
                  <Typography marginTop={2} color={currentlyFactoring ? "#616365" : "#c02424"} variant="subtitle1" component="div">
                    Are you currently factoring or financing your accounts receivable.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={6} xl={6}>
                  <RadioGroup
                    row
                    aria-labelledby="demo-form-control-label-placement"
                    name="currentlyFactoring"
                    {...bindCurrentlyFactoring}
                    required={true}
                    sx={"margin-top:10px"}
                  >
                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                    <FormControlLabel value="false" control={<Radio />} label="No" />
                  </RadioGroup>
                </Grid>
                <Grid item xs={12} md={6} lg={6} xl={6} margin={'auto'} sx={{marginTop: "16px"}}>
                  <FormControl variant="standard"
                    fullWidth>
                    <InputLabel style={mc ? { color: '#616365' } : { color: '#FFAB00' }}>
                      MC#</InputLabel>
                    {/* <Input
                      {...bindMc}
                      name="mc"
                      id="mc"
                      type='number'
                    /> */}
                    <Input
                      {...bindMc}
                      name="mc"
                      id="mc"
                      autoComplete='off'
                      inputComponent={TextMaskCustomMCDOT}
                    />
                    <FormHelperText style={{ color: '#FFAB00' }}>{fieldValidationOwnerMCDOTOptional(mc, "MC#").msg}</FormHelperText>
                  </FormControl>
                </Grid>
              </>
            }
            </>
          }

          <Grid item xs={12} md={6} lg={6} xl={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                views={["year"]}
                label="Year Established"
                InputProps={{
                  inputComponent: TextMaskCustomYear
                }}
                renderInput={(params) =>
                  <TextField
                    {...params}
                    name='yearEstablished'
                    error={fieldValidation(yearEstablished, "Year Established").error}
                    helperText={fieldValidation(yearEstablished, "Year Established").msg}
                    fullWidth
                    required={true}
                    variant="standard"
                    sx={"margin-top:16px"}
                  // {...bindYearEstablished}

                  />

                }
                value={yearEstablished}
                onChange={(newValue) => {
                  setYearEstablished(newValue)
                }}
                maxDate={new Date()}  //maxDate
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <TextField
              id="businessState"
              placeholder="Business State"
              label="Business State"
              margin="normal"
              fullWidth
              variant="standard"
              select
              required={true}
              error={fieldValidation(businessState, "Business State").error}
              helperText={fieldValidation(businessState, "Business State").msg}
              name="businessState"
              {...bindBusinessState}
            >
              {(statesArr || []).map((states) => (
                <MenuItem key={states.code} value={states.code}>
                  {states.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          {/* {currentlyFactoring == "true" &&
            <Grid item xs={6}>
              <TextField
                placeholder="Factoring With?"
                label="Factoring With?"
                name="factoringWith"
                {...bindFactoringWith}
                fullWidth
                variant="standard"
                sx={"margin-top:10px"}
              />
            </Grid>
          } */}
        </Grid>
        <Grid textAlign="left" item xs={12} marginTop={6}>
          <Typography color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
            Other Important Information
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <Typography marginTop={3} color={isGambling ? "#616365" : "#c02424"} variant="subtitle1" component="div">
            Is this business involved in internet gambling?
            <HtmlTooltip
              title={
                <React.Fragment>
                  Certain transactions are prohibited from being processed through your relationship with TAB Bank
                  under the Unlawful Internet Gambling Enforcement Act of 2006 (“Act”) and related regulations that have been issued by
                  the Board of Governors of the Federal Reserve System and the United States Department Of The Treasury (“Regulation GG”).
                  TAB Bank is also required by the Act and Regulation GG to inform its commercial customers of this restriction. The
                  transactions which are prohibited are the following transactions or transmittals involving any credit, funds, instrument
                  or proceeds that the Act prohibits any person engaged in the business of betting or wagering (except for the activities
                  of a financial transaction provider, or any interactive computer service or telecommunications service) from knowingly
                  accepting, in connection with the participation of another person in unlawful Internet Gambling:
                  <br />
                  <br />
                  (1) Credit, or the
                  proceeds of credit, extended to or on behalf of such person (including credit extended through the use of a credit card);
                  <br />
                  <br />
                  (2) An electronic fund transfer, or funds transmitted by or through a money transmitting business, or the proceeds of an
                  electronic fund transfer or money transmitting service, from or on behalf of such other person;
                  <br />
                  <br />
                  (3) Any check, draft, or
                  similar instrument that is drawn on a payable at or through any financial institution.
                  <br />
                  <br />
                  <br />
                  Internet gambling will generally be deemed to be unlawful unless it is expressly authorized
                  by license issued by an appropriate State or Tribal authority. Please let us know if you
                  have any license issued by an appropriate State or Tribal authority.
                  <br />
                  <br />
                  Please let us know if you have any questions.
                </React.Fragment>
              }
            >
              <IconButton>
                <Info sx={{ fontSize: '16px' }} />
              </IconButton>
            </HtmlTooltip>
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <RadioGroup
            row
            aria-labelledby="demo-form-control-label-placement"
            name="isGambling"
            {...bindIsGambling}
            required={true}
            sx={"margin-top:20px"}
          >
            <FormControlLabel value="true" control={<Radio />} label="Yes" />
            <FormControlLabel value="false" control={<Radio />} label="No" />
          </RadioGroup>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <Typography marginTop={2.5} color={isMoneyService ? "#616365" : "#c02424"} variant="subtitle1" component="div">
            Is this business a Money Services Business?
            <HtmlTooltip
              title={
                <React.Fragment>
                  You may be considered an MSB if you:
                  <br />
                  <br />
                  (1) Cash checks or other monetary instruments in an amount greater than $1,000
                  for any person on any day in one or more transactions.
                  <br />
                  <br />
                  (2) Provide money transmission services.
                  <br />
                  <br />
                  (3) Issue or Sell Travelers Checks or Money Orders in an amount greater than $1,000
                  to any person on any day in one or more transactions.
                  <br />
                  <br />
                  (4) Accept the currency or other monetary instruments of one or more countries in
                  exchange for the currency of one or more other countries in an amount greater than
                  $1,000 for any person on any day in one or more transactions.
                  <br />
                  <br />
                  (5) Provide or Sell Prepaid Access.
                </React.Fragment>
              }
            >
              <IconButton>
                <Info sx={{ fontSize: '16px' }} />
              </IconButton>
            </HtmlTooltip>
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <RadioGroup
            row
            aria-labelledby="demo-form-control-label-placement"
            name="isMoneyService"
            {...bindIsMoneyService}
            required={true}
            sx={"margin-top:20px"}
          >
            <FormControlLabel value="true" control={<Radio />} label="Yes" />
            <FormControlLabel value="false" control={<Radio />} label="No" />
          </RadioGroup>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <Typography marginTop={3.5} color={isPEP ? "#616365" : "#c02424"} variant="subtitle1" component="div">
            Is any company officer, applicant, cardholder (driver) or guarantor a politically exposed person?
            <HtmlTooltip
              title={
                <React.Fragment>
                  Politically Exposed Person or PEP is a current or former senior foreign political figure,
                  their immediate family, and their close associates. Such an
                  individual must be tracked by financial institutions as they pose potential
                  reputational risk to regulated entities.
                </React.Fragment>
              }
            >
              <IconButton>
                <Info sx={{ fontSize: '16px' }} />
              </IconButton>
            </HtmlTooltip>
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <RadioGroup
            row
            aria-labelledby="demo-form-control-label-placement"
            name="isPEP"
            {...bindIsPEP}
            required={true}
            sx={"margin-top:20px"}
          >
            <FormControlLabel value="true" control={<Radio />} label="Yes" />
            <FormControlLabel value="false" control={<Radio />} label="No" />
          </RadioGroup>
        </Grid>
        {/* <Grid item xs={12} md={6} lg={6} xl={6}>
          <Typography marginTop={5} color={"#616365"} variant="subtitle1" component="div">
            How did you hear about us?
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <TextField
            id="sales-person"
            name="salesPerson"
            fullWidth
            variant="standard"
            required={true}
            sx={"margin-top: 20px"}
            value={applicantDetails?.helped_by}
            {...bindSalesPerson}
          >
          </TextField>
        </Grid> */}
        {/* Owners */}
        <Grid textAlign="left" item xs={12} marginTop={6}>
          <Typography color={'#616365'} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
            Business Owner / Authorized Signer / Guarantor / Beneficial Owner Information
          </Typography>
          <Typography color={'#616365'} variant="p" gutterBottom component="div">
            LEGAL ENTITY BENEFICIAL OWNERSHIP CERTIFICATION
            <HtmlTooltip
              title={
                <React.Fragment>
                  <br />
                  I. GENERAL INSTRUCTIONS
                  <br />
                  <br />
                  What is this section?
                  <br />
                  <br />
                  To help the government fight financial crime. Federal regulation requires certain financial institutions to obtain,
                  verify, and record information about the beneficial owners of legal entity customers. Legal entities can be abused
                  to disguise involvement in terrorist financing, money laundering, tax evasion, corruption, fraud, and other financial
                  crimes. Requiring the disclosure of key individuals who own or control a legal entity (i.e., the beneficial owners)
                  helps law enforcement investigate and persecute these crimes.
                  <br />
                  <br />
                  Who has to complete this section?
                  <br />
                  <br />
                  The form must be completed by the person opening a new account on behalf of a legal entity with any of the following U.S. financial institutions:
                  <br />
                  <br />
                  (i) a bank or credit union;
                  <br />
                  <br />
                  (ii) a broker or dealer in securities;
                  <br />
                  <br />
                  (iii) a mutual fund;
                  <br />
                  <br />
                  (iv) a futures commission merchant; or
                  <br />
                  <br />
                  (v) an introducing broker in commodities.
                  <br />
                  <br />
                  For the purpose of this form, a legal entity includes a corporation, limited liability company, or other entity that is created by a filing of a public document with a Secretary of State or similar office, a general partnership, and any similar business entity formed in the United States or a foreign country. Legal entity does not include sole proprietorships, unincorporated associations, or natural person opening account on their own behalf.
                  <br />
                  <br />
                  What information do I have to provide?
                  <br />
                  <br />
                  This form requires you to provide the name, address, date of birth and Social Security number (or passport number or other similar information, in the case of foreign persons) for the following individuals (i.e., the beneficial owners):
                  <br />
                  <br />
                  (i) Each individual, if any, who owns, directly or indirectly, 25 percent or more of the equity interests of the legal entity customer (e.g., each natural person that owns 25 percent of more of the shares of a corporation); and
                  <br />
                  <br />
                  (ii) An individual with significant responsibility for managing the legal entity customer (e.g., a Chief Executive Officer, Chief Financial Officer, Chief Operating Officer, Manager Member, General Partner, President, Vice President, or Treasurer).
                  <br />
                  <br />
                  The financial institution may also ask to see a copy of a driver’s license or other identifying document for each beneficial owner listed on this form.
                  <br />
                  <br />
                </React.Fragment>
              }
            >
              <IconButton>
                <Info sx={{ fontSize: '16px' }} />
              </IconButton>
            </HtmlTooltip>
          </Typography>

          

        </Grid>

        <Grid item xs={8} marginTop={2} ref={tabContainerRef}>
          <Tabs TabIndicatorProps={{ style: { background: !ownerValidate ? '#F8FBFD' : '#DFA79B', boxShadow: '0px 0px 3px #888888' } }} value={value} onChange={handleChange} aria-label="basic tabs example">
            {owners.map((owner, index) => (
              <Tab sx={{
                bgcolor: !ownerValidate ? '#F8FBFD' : '#DFA79B',
              }} label={`${!owner?.first_name ? `Owner ${index + 1}` : owner?.first_name} (${owner.ownership_percent}%)`} {...a11yProps(0)} />
            ))}
          </Tabs>
        </Grid>
        {owners.map((owner, index) => (
          <TabPanel value={value} index={index}>
            {/* Med to Large Screen */}
            {/* <Grid sx={{ fontSize: '14px', margin: 'auto', display: { xs: 'none', md: 'block' } }} item xs={12} md={12} lg={12} xl={12}>
              <FormGroup>
                <FormControlLabel control={
                  <Checkbox
                    size="small"
                    style={{ textAlign: 'center' }}
                    name='loan_guarantor'
                    onChange={event => handleChangeOwnerCheck(index, event)}
                    checked={owner.loan_guarantor} />
                } label="Check if this Owner will be Guaranteeing the loan?" />
              </FormGroup>
            </Grid> */}
            <Grid sx={{ fontSize: '14px', margin: 'auto' }} item xs={12} md={12} lg={12} xl={12}>
              <FormGroup>
                <FormControlLabel control={
                  <Checkbox
                    size="small"
                    style={{ textAlign: 'center' }}
                    name='beneficial_owner'
                    onChange={event => handleChangeOwnerCheck(index, event)}
                    checked={totalOwnership >= 25 ? true : owner.beneficial_owner} />
                } label="Check if this Owner is a Beneficial Owner?" />
              </FormGroup>
            </Grid>
            <Grid sx={{ fontSize: '14px', margin: 'auto' }} item xs={12} md={12} lg={12} xl={12}>
              <FormGroup>
                <FormControlLabel control={
                  <Checkbox
                    size="small"
                    style={{ textAlign: 'center' }}
                    name='control_owner'
                    onChange={event => handleChangeOwnerCheck(index, event)}
                    checked={owner.control_owner} />
                } label="Check if this is an Individual with Control?" />
              </FormGroup>
            </Grid>
            <Grid sx={{ fontSize: '14px', margin: 'auto', display: { xs: 'none', md: 'block' } }} item xs={12} md={12} lg={12} xl={12}>
              <Typography color={'#616365'} variant="p" gutterBottom component="div">
                II. CERTIFICATION OF BENEFICIAL OWNER(S)
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      <br />
                      II. CERTIFICATION OF BENEFICIAL OWNER(S)
                      <br />
                      <br />
                      Persons opening an account on behalf of a legal entity must provide the following information:
                      <br />
                      <br />
                      a. Name and Title of Person opening account.
                      <br />
                      <br />
                      b. Name of Legal Entity for which the account is being opened.
                      <br />
                      <br />
                      c. The following information for each individual, if any, who directly or indirectly, through
                      any contract, arrangement, understanding, relationship or otherwise, owns 25 percent or more
                      of the equity interests of the legal entity listed above:
                      <br />
                      <br />
                      (Legal Definition)
                      <br />
                      <br />
                      The following question regarding an “individual with control” is for one individual with significant responsibility
                      for managing the legal entity listed above, such as:
                      <br />
                      <br />
                      An executive officer or senior manager (e.g., Chief Executive Officer, Chief Financial Officer, Chief Operating Officer,
                      Managing Member, General Partner, President, Vice President, Treasurer); or
                      <br />
                      <br />
                      Any other individual who regularly performs similar functions.
                      <br />
                      <br />
                    </React.Fragment>
                  }
                >
                  <IconButton>
                    <Info sx={{ fontSize: '16px' }} />
                  </IconButton>
                </HtmlTooltip>
              </Typography>
            </Grid>
            <Grid sx={{ fontSize: '14px', margin: 'auto' }} item xs={12} md={6} lg={6} xl={6} textAlign="right">
              <Button size="small" color="error" endIcon={<Delete />} onClick={handleClickOpen} >Remove Owner</Button>
            </Grid>
            {/* Small Screen */}
            {/* <Grid sx={{ display: { xs: 'block', sm: 'none' } }} item xs={12} md={6} lg={6} xl={6}>
              <FormGroup>
                <FormControlLabel control={
                  <Checkbox
                    size="small"
                    name='loan_guarantor'
                    onChange={event => handleChangeOwnerCheck(index, event)}
                    checked={owner.loan_guarantor} />
                } label={<Typography textAlign={'right'} marginLeft={'11px'} variant="subtitle2" color="textSecondary">Check if this Owner will be Guaranteeing the loan?</Typography>} />
              </FormGroup>
            </Grid>
            <Grid sx={{ display: { xs: 'block', sm: 'none' } }} item xs={12} md={6} lg={6} marginTop={'20px'} xl={6} textAlign="right">
              <Button size="small" style={{ fontSize: '12px', textAlign: 'right' }} color="error" startIcon={<Delete />} onClick={handleClickOpen} >Remove Owner</Button>
            </Grid> */}
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Remove Owner"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to remove this owner?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={() => handleRemoveOwner(index)}>
                  Yes
                </Button>
              </DialogActions>
            </Dialog>
            <Grid item xs={12}>
              <Typography marginTop={4} color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
                Basic Information
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <TextField
                placeholder="First Name"
                label="First Name"
                name='first_name'
                autoComplete='off'
                onChange={event => handleChangeOwner(index, event)}
                value={owner.first_name}
                required={true}
                error={fieldValidation(owner.first_name, "First Name").error}
                helperText={fieldValidation(owner.first_name, "First Name").msg}
                fullWidth
                variant="standard"
                sx={"margin-top:20px"}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <TextField
                placeholder="Middle Name"
                label="Middle Name"
                name='middle_name'
                autoComplete='off'
                onChange={event => handleChangeOwner(index, event)}
                value={owner.middle_name}
                // required={true}
                // error={fieldValidation(owner.middle_name,"Middle Name").error}
                // helperText={fieldValidation(owner.middle_name,"Middle Name").msg}
                fullWidth
                variant="standard"
                sx={"margin-top:20px"}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <TextField
                placeholder="Last Name"
                label="Last Name"
                name='last_name'
                autoComplete='off'
                onChange={event => handleChangeOwner(index, event)}
                value={owner.last_name}
                required={true}
                error={fieldValidation(owner.last_name, "Last Name").error}
                helperText={fieldValidation(owner.last_name, "Last Name").msg}
                fullWidth
                variant="standard"
                sx={"margin-top:20px"}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <TextField
                placeholder="Email Address"
                label="Email Address"
                name='email'
                autoComplete='off'
                onChange={event => handleChangeOwner(index, event)}
                value={owner.email}
                required={true}
                error={fieldValidationEmail(owner.email, "Email Address").error}
                helperText={fieldValidationEmail(owner.email, "Email Address").msg}
                fullWidth
                variant="standard"
                sx={"margin-top:20px"}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <FormControl variant="standard" margin="normal"
                fullWidth>
                <InputLabel htmlFor="formatted-text-mask-input">Mobile</InputLabel>
                <Input
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.mobile_phone}
                  autoComplete='off'
                  name="mobile_phone"
                  id="Mobile"
                  inputComponent={TextMaskCustomPhone}
                />
                {/* <FormHelperText>{fieldValidationPhone(owner.mobile_phone, "Mobile").msg}</FormHelperText> */}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <FormControl variant="standard" margin="normal"
                fullWidth>
                <InputLabel htmlFor="formatted-text-mask-input">Home</InputLabel>
                <Input
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.home_phone}
                  name="home_phone"
                  id="Home"
                  autoComplete='off'
                  inputComponent={TextMaskCustomPhone}
                />
                {/* <FormHelperText>{fieldValidationPhone(owner.home_phone, "Home Phone").msg}</FormHelperText> */}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Date of Birth *"
                  InputProps={{
                    inputComponent: TextMaskCustomDate
                  }}
                  renderInput={(params) => <TextField
                    {...params}
                    name='date_of_birth'
                    autoComplete='off'
                    error={fieldValidationLegalAge(owner.date_of_birth, "Date of Birth").error}
                    helperText={fieldValidationLegalAge(owner.date_of_birth, "Date of Birth").msg}
                    fullWidth
                    variant="standard"
                    sx={"margin-top:20px"}
                    format="dd/MM/yyyy"                    
                    value={owner.date_of_birth}
                    onChange={event => handleChangeOwner(index, event)}
                  />}
                  onChange={(newValue) => {
                    handleChangeOwnerDate(index, 'date_of_birth', newValue)
                  }}
                  value={owner.date_of_birth}
                  maxDate={moment().subtract(18, 'years')._d}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <FormControl required={true} error={fieldValidationSSN(owner.ssn, "SSN").error} variant="standard" margin="normal"
                fullWidth>
                <InputLabel htmlFor="formatted-text-mask-input">SSN</InputLabel>
                <Input
                  name="ssn"
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.ssn}
                  id="ssn"
                  autoComplete='off'
                  type={showSSN ? 'text' : 'password'}
                  inputComponent={TextMaskCustomSSN}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowSSN}
                        onMouseDown={handleMouseDownSSN}
                        edge="end"
                      >
                        {showSSN ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <FormHelperText>{fieldValidationSSN(owner.ssn, "SSN").msg}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <TextField
                placeholder="Title"
                label="Title"
                name='title'
                autoComplete='off'
                onChange={event => handleChangeOwner(index, event)}
                value={owner.title}
                required={true}
                error={fieldValidation(owner.title, "Title").error}
                helperText={fieldValidation(owner.title, "Title").msg}
                fullWidth
                variant="standard"
                sx={"margin-top:20px"}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <FormControl required={true} error={fieldValidationFloat(owner.ownership_percent, "Ownership %").error} variant="standard" margin="normal"
                fullWidth>
                <InputLabel htmlFor="formatted-text-mask-input">Ownership %</InputLabel>
                <Input
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.ownership_percent}
                  name="ownership_percent"
                  id="ownership_percent"
                  autoComplete='off'
                  inputComponent={TextMaskCustomPercent}
                />
                <FormHelperText>{fieldValidationFloat(owner.ownership_percent, "Ownership %").msg}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <FormControl required={true} error={fieldValidation0to99(owner.years_driving, "Years Driving").error} variant="standard" margin="normal"
                fullWidth>
                <InputLabel htmlFor="formatted-text-mask-input">Years Driving</InputLabel>
                <Input
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.years_driving}
                  name="years_driving"
                  id="years_driving"
                  autoComplete='off'
                  inputComponent={TextMaskCustom0to99}
                />
                <FormHelperText>{fieldValidation0to99(owner.years_driving, "Years Driving").msg}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} marginTop={4}>
              <Typography marginTop={4} color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
                Physical Address
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <TextField
                placeholder="Address"
                label="Address"
                name='phys_address1'
                onChange={event => handleChangeOwner(index, event)}
                value={owner.phys_address1}
                required={true}
                error={fieldValidation(owner.phys_address1, "Address").error}
                helperText={fieldValidation(owner.phys_address1, "Address").msg}
                fullWidth
                variant="standard"
                sx={"margin-top:20px"}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <TextField
                placeholder="City"
                label="City"
                name='phys_city'
                onChange={event => handleChangeOwner(index, event)}
                value={owner.phys_city}
                required={true}
                error={fieldValidation(owner.phys_city, "City").error}
                helperText={fieldValidation(owner.phys_city, "City").msg}
                fullWidth
                variant="standard"
                sx={"margin-top:20px"}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <TextField
                id="state"
                placeholder="State"
                label="State"
                margin="normal"
                fullWidth
                variant="standard"
                select
                required={true}
                error={fieldValidation(owner.phys_state, "State").error}
                helperText={fieldValidation(owner.phys_state, "State").msg}
                name="phys_state"
                onChange={event => handleChangeOwner(index, event)}
                value={owner.phys_state}
              >
                {(statesArr || []).map((states) => (
                  <MenuItem key={states.code} value={states.code}>
                    {states.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <FormControl required={true} error={fieldValidationZipCode(owner.phys_zipcode, "Zip Code").error} variant="standard" margin="normal"
                fullWidth>
                <InputLabel htmlFor="formatted-text-mask-input">Zip Code</InputLabel>
                <Input
                  name='phys_zipcode'
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.phys_zipcode}
                  id="phys_zipcode"
                  inputComponent={TextMaskCustomZipCode}
                />
                <FormHelperText>{fieldValidationZipCode(owner.phys_zipcode, "Zip Code").msg}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6} marginTop={4}>
              <Typography marginTop={4} color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
                Mailing Address
              </Typography>
            </Grid>
            <Grid item xs={12} color={"#616365"} marginTop={2}>
              <FormGroup>
                <FormControlLabel control={
                  <Checkbox
                    name='same_address'
                    onChange={event => handleChangeOwnerCheck(index, event)}
                    checked={owner.same_address} />
                } label="Check if mailing address is same as physical address" />
              </FormGroup>
            </Grid>
            {/* {owner.same_address != true && */}
            <>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  placeholder="Address"
                  label="Address"
                  name='mail_address1'
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.mail_address1}
                  required={true}
                  error={fieldValidation(owner.mail_address1, "Address").error}
                  helperText={fieldValidation(owner.mail_address1, "Address").msg}
                  fullWidth
                  variant="standard"
                  sx={"margin-top:20px"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  placeholder="City"
                  label="City"
                  name='mail_city'
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.mail_city}
                  required={true}
                  error={fieldValidation(owner.mail_city, "City").error}
                  helperText={fieldValidation(owner.mail_city, "City").msg}
                  fullWidth
                  variant="standard"
                  sx={"margin-top:20px"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  id="state"
                  placeholder="State"
                  label="State"
                  margin="normal"
                  fullWidth
                  variant="standard"
                  select
                  required={true}
                  error={fieldValidation(owner.mail_state, "State").error}
                  helperText={fieldValidation(owner.mail_state, "State").msg}
                  name="mail_state"
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.mail_state}
                >
                  {(statesArr || []).map((states) => (
                    <MenuItem key={states.code} value={states.code}>
                      {states.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <FormControl required={true} error={fieldValidationZipCode(owner.mail_zipcode, "Zip Code").error} variant="standard" margin="normal"
                  fullWidth>
                  <InputLabel htmlFor="formatted-text-mask-input">Zip Code</InputLabel>
                  <Input
                    name='mail_zipcode'
                    onChange={event => handleChangeOwner(index, event)}
                    value={owner.mail_zipcode}
                    id="mail_zipcode"
                    inputComponent={TextMaskCustomZipCode}
                  />
                  <FormHelperText>{fieldValidationZipCode(owner.mail_zipcode, "Zip Code").msg}</FormHelperText>
                </FormControl>
              </Grid>
            </>
            {/* GARAGING ADDRESS - WHERE EQUIPMENT IS BEING HELD */}
            <Grid item xs={12} md={6} lg={6} xl={6} marginTop={4}>
              <Typography marginTop={4} color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
                Garaging Address
              </Typography>
            </Grid>
            <Grid item xs={12} color={"#616365"} marginTop={2}>
              <FormGroup>
                <FormControlLabel control={
                  <Checkbox
                    name='same_address_garage'
                    onChange={event => handleChangeOwnerCheck(index, event)}
                    checked={owner.same_address_garage} />
                } label="Check if garage address is same as physical address" />
              </FormGroup>
            </Grid>
            {/* {owner.same_address != true && */}
            <>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  placeholder="Address"
                  label="Address"
                  name='garage_address1'
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.garage_address1}
                  required={true}
                  error={fieldValidation(owner.garage_address1, "Garage Address").error}
                  helperText={fieldValidation(owner.garage_address1, "Garage Address").msg}
                  fullWidth
                  variant="standard"
                  sx={"margin-top:20px"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  placeholder="City"
                  label="City"
                  name='garage_city'
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.garage_city}
                  required={true}
                  error={fieldValidation(owner.garage_city, "Garage City").error}
                  helperText={fieldValidation(owner.garage_city, "Garage City").msg}
                  fullWidth
                  variant="standard"
                  sx={"margin-top:20px"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  id="state"
                  placeholder="State"
                  label="State"
                  margin="normal"
                  fullWidth
                  variant="standard"
                  select
                  required={true}
                  error={fieldValidation(owner.garage_state, "Garage State").error}
                  helperText={fieldValidation(owner.garage_state, "Garage State").msg}
                  name="garage_state"
                  onChange={event => handleChangeOwner(index, event)}
                  value={owner.garage_state}
                >
                  {(statesArr || []).map((states) => (
                    <MenuItem key={states.code} value={states.code}>
                      {states.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <FormControl required={true} error={fieldValidationZipCode(owner.garage_zipcode, "Garage Zip Code").error} variant="standard" margin="normal"
                  fullWidth>
                  <InputLabel htmlFor="formatted-text-mask-input">Zip Code</InputLabel>
                  <Input
                    name='garage_zipcode'
                    onChange={event => handleChangeOwner(index, event)}
                    value={owner.garage_zipcode}
                    id="garage_zipcode"
                    inputComponent={TextMaskCustomZipCode}
                  />
                  <FormHelperText>{fieldValidationZipCode(owner.garage_zipcode, "Garage Zip Code").msg}</FormHelperText>
                </FormControl>
              </Grid>
            </>
            {/* } */}
            {/* <Grid item xs={12} md={6} lg={6} xl={6}>
              <Typography marginTop={4} color={"#616365"} variant="subtitle1" component="div">
                Politically exposed Person?
              </Typography>
              <Typography marginTop={4} color={"#616365"} fontSize={'10px'} component="div">
                a Politically Exposed Person is someone who, through their prominent position or influence, is more susceptible to being involved in bribery or corruption.
              </Typography>
            </Grid> */}
            {/* <Grid item xs={12} md={6} lg={6} xl={6}>
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name='politically_exposed'
                onChange={event => handleRadioButtons(index, event)}
                value={owner.politically_exposed}
                required={true}
                sx={"margin-top:20px"}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid> */}
            <Grid item xs={12} marginTop={4}>
              <Typography marginTop={4} color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
                Legal Information
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <Typography marginTop={4} color={owner.declared_bankruptcy ? "#616365" : "#c02424"}
                variant="subtitle1" component="div">
                Have you ever declared bankruptcy?
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name='declared_bankruptcy'
                onChange={event => handleChangeOwner(index, event)}
                value={owner.declared_bankruptcy}
                required={true}
                sx={"margin-top:20px"}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <Typography marginTop={4} color={owner.defendant_legal ? "#616365" : "#c02424"} variant="subtitle1" component="div">
                Are you a defendant in any Legal Action?
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name='defendant_legal'
                onChange={event => handleChangeOwner(index, event)}
                value={owner.defendant_legal}
                required={true}
                sx={"margin-top:20px"}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <Typography marginTop={4} color={owner.item_repossessed ? "#616365" : "#c02424"} variant="subtitle1" component="div">
                Have you ever had an item repossessed?
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name='item_repossessed'
                onChange={event => handleChangeOwner(index, event)}
                value={owner.item_repossessed}
                required={true}
                sx={"margin-top:20px"}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
          </TabPanel>
        ))}
            {/* <Grid item xs={12} md={6} lg={6} xl={6} marginTop={1}>
              <Chip
                label={`Note: (${totalOwnership ? totalOwnership : '0'}% Total Ownership) > 66.66%`}
                sx={{
                  bgcolor: totalOwnership >= 66.66 ? '#3f51b5' : '#DFA79B',
                  color: totalOwnership >= 66.66 ? '#ffffff' : '#616365',
                }}
              />
            </Grid> */}
            <Grid textAlign={'right'} item xs={12} md={12} lg={12} xl={12} marginTop={3}>
              <Button sx={{ backgroundColor: '#3f51b5', fontSize: '18px' }} size="medium" variant="contained" endIcon={<AddIcon />} onClick={() => handleAddOwner()}>Add</Button>
            </Grid>
        {/* <Grid item xs={12} md={6} lg={6} xl={6} marginTop={4}>
          <Typography color={withDebtors ? "#616365" : "#c02424"} variant="subtitle1" component="div">
            Do any of your customers currently comprise more than 10% of your open accounts receivable?
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6} marginTop={4}>
          <RadioGroup
            row
            aria-labelledby="demo-form-control-label-placement"
            name="position"
            required={true}
            sx={"margin-top:10px"}
            error={withDebtors ? false : true}
            {...bindWithDebtors}
          >
            <FormControlLabel value="true" control={<Radio />} label="Yes" />
            <FormControlLabel value="false" control={<Radio />} label="No" />
          </RadioGroup>
        </Grid> */}
        {withDebtors == 'true' && <>
          {/* DEBTORS */}
          <Grid textAlign="left" item xs={12} marginTop={6}>
            <Typography color={'#616365'} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
              Debtors
            </Typography>
          </Grid>
          <Grid textAlign={'right'} item xs={12}>
            <Button sx={{ backgroundColor: '#3f51b5' }} size="medium" variant="contained" endIcon={<AddIcon />} onClick={() => handleAddDebtor()}>Add</Button>
          </Grid>

          {/* HIDE AND SHOW DEBTORS HERE */}

          <Grid item xs={8} marginTop={2}>

            <Tabs TabIndicatorProps={{ style: { background: !debtorValidate ? '#F8FBFD' : '#DFA79B', boxShadow: '0px 0px 3px #888888' } }} value={valueDebtors} onChange={switchDebtorsTab} aria-label="basic tabs example">

              {debtors.map((debtor, index) => (
                <Tab sx={{
                  bgcolor: !debtorValidate ? '#F8FBFD' : '#DFA79B',
                }} label={`${!debtor?.name ? `DEBTOR ${index + 1}` : debtor?.name}`} />
              ))}
            </Tabs>
          </Grid>
          {debtors.map((debtor, index) => (
            <TabPanel value={valueDebtors} index={index}>
              <Grid item xs={6}></Grid>
              <Grid item xs={6} textAlign="right">
                <Button size="small" color="error" endIcon={<Delete />} onClick={handleClickOpenDebtors} >Remove DEBTOR</Button>
              </Grid>
              <Dialog
                open={openDebtor}
                onClose={handleCloseDebtors}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Remove Debtor"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to remove this debtor?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseDebtors}>Cancel</Button>
                  <Button onClick={() => handleRemoveDebtor(index)}>
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
              <Grid item xs={12}>
                <Typography color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
                  Information
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  placeholder="Name"
                  label="Name"
                  name='name'
                  onChange={event => handleChangeDebtor(index, event)}
                  value={debtor.name}
                  required={true}
                  error={fieldValidation(debtor.name, "Name").error}
                  helperText={fieldValidation(debtor.name, "Name").msg}
                  fullWidth
                  variant="standard"
                  sx={"margin-top:20px"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  placeholder="Email Address"
                  label="Email Address"
                  name='email'
                  onChange={event => handleChangeDebtor(index, event)}
                  value={debtor.email}
                  required={true}
                  error={fieldValidationEmail(debtor.email, "Email Address").error}
                  helperText={fieldValidationEmail(debtor.email, "Email Address").msg}
                  fullWidth
                  variant="standard"
                  sx={"margin-top:20px"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <FormControl required={true} error={fieldValidationPhone(debtor.phone, "Phone").error} variant="standard" margin="normal"
                  fullWidth>
                  <InputLabel htmlFor="formatted-text-mask-input">Phone</InputLabel>
                  <Input
                    onChange={event => handleChangeDebtor(index, event)}
                    value={debtor.phone}
                    name="phone"
                    id="phone"
                    inputComponent={TextMaskCustomPhone}
                  />
                  <FormHelperText>{fieldValidationPhone(debtor.phone, "Mobile").msg}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <FormControl helperText={fieldValidationWebsite(debtor.website, "Website").msg} variant="standard" margin="normal"
                  fullWidth>
                  <InputLabel htmlFor="formatted-text-mask-input">Website</InputLabel>
                  <Input
                    onChange={event => handleChangeDebtor(index, event)}
                    value={debtor.website}
                    name="website"
                    id="website"
                  />
                  <FormHelperText>{fieldValidationWebsite(debtor.website, "Website").msg}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <FormControl helperText={fieldValidationTaxID(debtor.ein, "Tax ID").msg} variant="standard" margin="normal"
                  fullWidth>
                  <InputLabel htmlFor="formatted-text-mask-input">Tax ID</InputLabel>
                  <Input
                    onChange={event => handleChangeDebtor(index, event)}
                    value={debtor.ein}
                    name="ein"
                    type={showTaxId ? 'text' : 'password'}
                    id="ein"
                    autoComplete='off'
                    inputComponent={TextMaskCustomTaxID}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowTaxId}
                          onMouseDown={handleMouseDownTaxId}
                          edge="end"
                        >
                          {showTaxId ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <FormHelperText>{fieldValidationTaxID(debtor.ein, "Tax ID").msg}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <FormControl helperText={fieldValidationMCDOT(debtor.mc, "MC#").msg} variant="standard" margin="normal"
                  fullWidth>
                  <InputLabel htmlFor="formatted-text-mask-input">MC#</InputLabel>
                  <Input
                    onChange={event => handleChangeDebtor(index, event)}
                    value={debtor.mc}
                    name="mc"
                    id="mc"
                  />
                  <FormHelperText>{fieldValidationMCDOT(debtor.mc, "MC#").msg}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <FormControl helperText={fieldValidationMCDOT(debtor.dot, "USDOT#").msg} variant="standard" margin="normal"
                  fullWidth>
                  <InputLabel htmlFor="formatted-text-mask-input">USDOT#</InputLabel>
                  <Input
                    onChange={event => handleChangeDebtor(index, event)}
                    value={debtor.dot}
                    name="dot"
                    id="dot"
                  />
                  <FormHelperText>{fieldValidationMCDOT(debtor.dot, "USDOT#").msg}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <FormControl required={true} error={fieldValidationAmount(debtor.invoice_amount, "Invoice Amount").error} variant="standard" margin="normal"
                  fullWidth>
                  <InputLabel htmlFor="formatted-text-mask-input">Invoice Amount</InputLabel>
                  <Input
                    onChange={event => handleChangeDebtor(index, event)}
                    onBlur={event => handleInvoiceAmount(index, event)}
                    startAdornment={<InputAdornment position="start">$</InputAdornment>}
                    type="number"
                    value={debtor.invoice_amount}
                    name="invoice_amount"
                    id="invoice_amount"
                  />
                  <FormHelperText>{fieldValidationAmount(debtor.invoice_amount, "Invoice Amount").msg}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} marginTop={4}>
                <Typography marginTop={4} color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
                  Address
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  placeholder="Address"
                  label="Address"
                  name='address1'
                  onChange={event => handleChangeDebtor(index, event)}
                  value={debtor.address1}
                  required={true}
                  error={fieldValidation(debtor.address1, "Address").error}
                  helperText={fieldValidation(debtor.address1, "Address").msg}
                  fullWidth
                  variant="standard"
                  sx={"margin-top:20px"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  placeholder="City"
                  label="City"
                  name='city'
                  onChange={event => handleChangeDebtor(index, event)}
                  value={debtor.city}
                  required={true}
                  error={fieldValidation(debtor.city, "City").error}
                  helperText={fieldValidation(debtor.city, "City").msg}
                  fullWidth
                  variant="standard"
                  sx={"margin-top:20px"}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <TextField
                  id="state"
                  placeholder="State"
                  label="State"
                  margin="normal"
                  fullWidth
                  variant="standard"
                  select
                  required={true}
                  error={fieldValidation(debtor.state, "State").error}
                  helperText={fieldValidation(debtor.state, "State").msg}
                  name="state"
                  onChange={event => handleChangeDebtor(index, event)}
                  value={debtor.state}
                >
                  {(statesArr || []).map((states) => (
                    <MenuItem key={states.code} value={states.code}>
                      {states.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={6} lg={6} xl={6}>
                <FormControl required={true} error={fieldValidationZipCode(debtor.zipcode, "Zip Code").error} variant="standard" margin="normal"
                  fullWidth>
                  <InputLabel htmlFor="formatted-text-mask-input">Zip Code</InputLabel>
                  <Input
                    name='zipcode'
                    onChange={event => handleChangeDebtor(index, event)}
                    value={debtor.zipcode}
                    id="zipcode"
                    inputComponent={TextMaskCustomZipCode}
                  />
                  <FormHelperText>{fieldValidationZipCode(debtor.zipcode, "Zip Code").msg}</FormHelperText>
                </FormControl>
              </Grid>
            </TabPanel>
          ))}
          {/* HIDE AND SHOW DEBTORS HERE */}
        </>
        }

      </Grid>
      <StepButtons updateInfo={onUpdateBusinessInfo} ref={ref} />
    </>
  )
}

export default forwardRef(BusinessInfo)